/* ============
 * Mutation types for the users module
 * ============
 *
 * The mutation types that are available
 * on the users module.
 */

export const USERS = 'USERS';
export const PROJECTRMDETAILS = 'PROJECTRMDETAILS';
export const BROKERAPPROVALS = 'BROKERAPPROVALS';
export const CUSTOMERSANDBROKERSLIST = 'CUSTOMERSANDBROKERSLIST';
export const DRMLIST = 'DRMLIST';
export const DEVLIST = 'DEVLIST';
export const OTHERUSER = 'OTHERUSER';
export const STOREFORMULADATA = 'STOREFORMULADATA';
export const REMOVEFORMULADATA = 'REMOVEFORMULADATA';

export default {
  USERS,
  PROJECTRMDETAILS,
  BROKERAPPROVALS,
  CUSTOMERSANDBROKERSLIST,
  DRMLIST,
  STOREFORMULADATA,
  REMOVEFORMULADATA,
  DEVLIST,
  OTHERUSER,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/mutation-types.js